import { convertCreditsFromServerToClient } from "../../../datastructures/Credits";
import { CommonData } from "../../../datastructures/gamestate/gameData";

export class BuyBonusCard {
  //default dimension 500x800
  private totalCards:number=0;
  private parent: PIXI.Container = new PIXI.Container();
  private cardParent: PIXI.Container = new PIXI.Container();
  private priceContainer: PIXI.Container = new PIXI.Container();
  private maskShape: PIXI.Graphics;

  private contentText: PIXI.Text;

  private activeGameData: CommonData;
  private cardBG: PIXI.Sprite = new PIXI.Sprite(
    PIXI.Texture.fromFrame("bgSmallWin.png")
  );
  private buyButton:PIXI.Sprite=new PIXI.Sprite(PIXI.Texture.fromFrame('buyInBtn.png'));// PIXI.Graphics; //().beginFill(0xff0000).drawRoundedRect(-250,-400,500,800,30).endFill();
  private priceBG: PIXI.Sprite = new PIXI.Sprite(
    PIXI.Texture.fromFrame("bgSmallWin.png")
  );

  private promotionPicture: PIXI.Sprite = new PIXI.Sprite(
    PIXI.Texture.fromFrame("ZoomingFx.png")
  );
  private cardSize: Array<number>;

  private text_upperTitel: PIXI.Text;
  private text_loweTitel: PIXI.Text;
  private text_btnLabel: PIXI.Text;
  private text_currency: PIXI.Text;
  private text_prizeDecimal: PIXI.Text;
  private text_prizeWholeNumber: PIXI.Text;
  private tweenMoveLeft: PIXI.tween.Tween;
  private tweenMoveRight: PIXI.tween.Tween;
  // private serverValue:number=0;
  private cardIndex:number=0;
  private sideCardScaleX:number=1;
  private sideCardScaleY:number=1;
  private isPortrait:boolean=false

  private offsetMove:number=0;
  private offSetValuePortrait:number=0;
  private offSetValuelandscape:number=0;
  private desaturateMatrix:PIXI.filters.ColorMatrixFilter; 
  constructor(
    parent: PIXI.Container,
    cardSize: Array<number>,
    activeGameData: CommonData, index:number,totalCards:number,offsetBewteenCards:number
  ) {
    this.offsetMove=offsetBewteenCards;
    this.offSetValuelandscape=offsetBewteenCards;
    this.offSetValuePortrait=offsetBewteenCards*2;
    this.totalCards=totalCards;
    this.cardIndex=index;
    this.cardSize = cardSize;
    this.activeGameData = activeGameData;
    parent.addChild(this.parent);
    this.parent.addChild(this.cardParent);
    this.maskShape = new PIXI.Graphics()
      .beginFill(0xff0000)
      .drawRoundedRect(
        -cardSize[0] / 2,
        -cardSize[1] / 2,
        cardSize[0],
        cardSize[1],
        30
      )
      .endFill();
    this.cardParent.addChild(this.maskShape);
    this.cardParent.addChild(this.cardBG);
    this.cardBG.width = cardSize[0] * 1.3;
    this.cardBG.height = cardSize[1] * 1.3;
    this.cardBG.anchor.set(0.5);
    this.cardBG.mask = this.maskShape;

    // //--matrix filter
    // const colorMatrix = new PIXI.filters.ColorMatrixFilter();
    // const colorMatrix2 = new PIXI.filters.ColorMatrixFilter();
    // // this.cardBG.filters = [colorMatrix, colorMatrix2];
    // colorMatrix2.saturate(3);
    // colorMatrix.hue(-180);
    this.desaturateMatrix  = new PIXI.filters.ColorMatrixFilter();
    this.desaturateMatrix.desaturate();



    let font = this.activeGameData.gameTextStyle.gameFont;

    this.cardParent.addChild(this.promotionPicture);
    this.promotionPicture.anchor.set(0.5);
    this.promotionPicture.scale.set(1);

    // this.promotionPicture.mask = this.maskShape;
    ////------------decoration STROKE
    // let strokeOffsetX = 1.05;

    // let cardOffsetXinPixels = cardSize[0] - cardSize[0] * strokeOffsetX;
    // let strokeOffsetY = (cardSize[1] - cardOffsetXinPixels) / cardSize[1];
    // let outerStroke = new PIXI.Graphics()
    //   .lineStyle(5, 0xfff0f0, 0.55)
    //   .drawRoundedRect(
    //     (-cardSize[0] / 2) * strokeOffsetX,
    //     (-cardSize[1] / 2) * strokeOffsetY,
    //     cardSize[0] * strokeOffsetX,
    //     cardSize[1] * strokeOffsetY,
    //     35
    //   )
    //   .endFill();
    // this.cardParent.addChild(outerStroke);

    // strokeOffsetX = 0.95;
    // cardOffsetXinPixels = cardSize[0] - cardSize[0] * strokeOffsetX;
    // strokeOffsetY = (cardSize[1] - cardOffsetXinPixels) / cardSize[1];
    // let innerStroke = new PIXI.Graphics()
      // .lineStyle(5, 0xfff0f0, 0.55)
      // .drawRoundedRect(
      //   (-cardSize[0] / 2) * strokeOffsetX,
      //   (-cardSize[1] / 2) * strokeOffsetY,
      //   cardSize[0] * strokeOffsetX,
      //   cardSize[1] * strokeOffsetY,
      //   20
      // )
      // .endFill();
    // this.cardParent.addChild(innerStroke);

    //---end decoration

    // let btnSizeX = cardSize[0] * .75;
    // let btnSizeY = 80;
    // this.buyButton = new PIXI.Graphics().beginFill(0xffcf64).lineStyle(3, 0xfefbf2, 0.7, 1).drawRoundedRect(-btnSizeX/2, -btnSizeY/2, btnSizeX, btnSizeY, 5).endFill();
    // this.btnShape[i].x = i * this.btnShape[i].width * 1.25; //Stroke offset
    // this.btnShape[i].y = this.boxHeight - this.btnShape[i].height * 1.5;

    // this.buyButton= new PIXI.Sprite(PIXI.Texture.fromFrame ('buyInBtn.png'))
    this.buyButton.anchor.set(.5);
    this.buyButton.y = cardSize[1] / 2;
        // console.log( this.buyButton.width, this.buyButton.height)
    this.cardParent.addChild(this.priceBG);

    this.priceBG.anchor.set(0.5);

    ////---text

    const styleTitle1 = new PIXI.TextStyle({
      dropShadow: true,
      dropShadowAngle: 90,
      fill: ["#fff5c2", "#ffa629"],
      fillGradientStops: [0, 1],
      fontFamily: font,
      fontSize: 100,
      fontWeight: "bold",
      lineJoin: "round",
      strokeThickness: 7,
    });

    const styleTitle2 = new PIXI.TextStyle({
      dropShadow: true,
      dropShadowAngle: 90,
      fill: ["#fff5c2", "#ffa629"],
      fillGradientStops: [0, 1],
      fontFamily: font,
      fontSize: 50,
      fontWeight: "bold",
      lineJoin: "round",
      strokeThickness: 7,
    });

    const styleTitleStake = new PIXI.TextStyle({
      dropShadow: false,
      dropShadowAngle: 0,
      fill: ["#fff5c2", "#ffa629"],
      fillGradientStops: [0, 1],
      fontFamily: font,
      fontSize: 50,
      fontWeight: "bold",
      lineJoin: "round",
      strokeThickness: 7,
    });

    const styleButtonLabel = new PIXI.TextStyle({
    
   
  
      fillGradientStops: [0, 1],
      fontFamily: font,
    
      lineJoin: "round",
      // strokeThickness: 7,

      dropShadow: true,
      dropShadowColor: "#d44a2d",
      dropShadowBlur: 10,
      dropShadowAngle: Math.PI / 6,
      dropShadowDistance: 0,
      fill: ["#000000"],
      fontWeight: "bold",
      fontSize: 45,
      align: "center",
    });
    const styleDecimal = new PIXI.TextStyle({
      dropShadow: true,
      dropShadowAngle: 40,
      fill: ["#fff5c2", "#ffa629"],
      fillGradientStops: [0, 1],
      fontFamily: font,
      fontSize: 50,
      fontWeight: "bold",
      lineJoin: "round",
      strokeThickness: 7,
    });

    this.text_upperTitel = new PIXI.Text(this.activeGameData.gameTextGeneral.BONUSBUYHEAD, styleTitle1);
    if (this.text_upperTitel.width > cardSize[0] * 0.95) {
      this.text_upperTitel.width = cardSize[0] * 0.95;
    }
    this.text_upperTitel.y = -this.maskShape.height / 2;
    this.text_upperTitel.anchor.set(0.5);

    this.text_loweTitel = new PIXI.Text(this.activeGameData.gameTextGeneral.BONUSBUYBODY, styleTitle2);
    if (this.text_loweTitel.width > cardSize[0] * 0.95) {
      this.text_loweTitel.width = cardSize[0] * 0.95;
    }
    this.text_loweTitel.y = -this.maskShape.height / 2 + 80;
    this.text_loweTitel.anchor.set(0.5);

    //-price in whole number

    this.cardParent.addChild(this.priceContainer);
    this.text_prizeWholeNumber = new PIXI.Text("5000.", styleTitle1);
    if (this.text_prizeWholeNumber.width > cardSize[0] * 0.95) {
      this.text_prizeWholeNumber.width = cardSize[0] * 0.95;
    }
    this.text_prizeWholeNumber.y =
      this.maskShape.height / 2 - this.text_prizeWholeNumber.height + 20;
    this.text_prizeWholeNumber.anchor.set(1, 0.5);
    this.priceBG.y = this.text_prizeWholeNumber.y;
    this.priceContainer.addChild(this.text_prizeWholeNumber);

    this.text_currency = new PIXI.Text(activeGameData.currency, styleDecimal);
    this.text_currency.anchor.set(0, 1);
    this.text_currency.scale.set(0.7);
    // this.text_currency.y=-1000;
    this.priceContainer.addChild(this.text_currency);

    this.text_prizeDecimal = new PIXI.Text("00", styleDecimal);
    this.text_prizeDecimal.anchor.set(0, 0.25);

    this.text_prizeDecimal.y = this.text_prizeWholeNumber.y; // -this.text_prizeDecimal.height*1.4;
    this.priceContainer.addChild(this.text_prizeDecimal);

    //current stake
    this.contentText = new PIXI.Text(activeGameData.gameTextGeneral.BUYPRICE, styleTitleStake);
    this.contentText.anchor.set(0.5);
    this.contentText.scale.set(this.sideCardScaleX);
    this.contentText.y =
      this.text_prizeWholeNumber.y - this.contentText.height *1.2;

    this.cardParent.addChild(this.text_upperTitel);
    this.cardParent.addChild(this.text_loweTitel);
    this.cardParent.addChild(this.contentText);

    this.text_currency.y = this.text_prizeWholeNumber.y;
    this.text_prizeDecimal.y = this.text_prizeWholeNumber.y;

    this.text_btnLabel = new PIXI.Text(" " + this.activeGameData.gameTextGeneral.BUY+" ", styleButtonLabel);

    if (this.text_btnLabel.width > this.buyButton.width * 0.95) {
      this.text_btnLabel.width = this.buyButton.width * 0.95;
    }
    this.text_btnLabel.anchor.set(0.5);
    this.cardParent.addChild(this.buyButton);

    this.buyButton.addChild(this.text_btnLabel);

    this.buyButton
      .on("mouseover", this.onHover)
      .on("mouseout", this.onOut);

    //

    this.buyButton.on('pointertap',this.onMakeBuyRequest);

    this.tweenMoveLeft = PIXI.tweenManager.createTween(this.cardParent);
   
  
    this.tweenMoveLeft.time = 500;
    this.tweenMoveLeft.easing = PIXI.tween.Easing.outBack();
    this.tweenMoveLeft.loop = false;
    // this.tweenMoveLeft.delay=this.cardIndex*50;

    this.tweenMoveRight = PIXI.tweenManager.createTween(this.cardParent);




    this.tweenMoveRight.time = this.tweenMoveLeft.time;
    this.tweenMoveRight.easing = this.tweenMoveLeft.easing;
    this.tweenMoveRight.loop = false;

    // this.tweenMoveRight.delay=this.cardIndex*50;

    this.setBuyVisible(true); //by default but btn hidden


    this.tweenMoveLeft.on('end',this.moveEndUpdate);
    this.tweenMoveRight.on('end',this.moveEndUpdate);
    //    this.updatePrice(1234500);

  }



  private enableBtn=(bool:boolean):void=>
  {
    this.buyButton.interactive=bool;
    this.buyButton.buttonMode=bool;
   

    this.buyButton.filters= bool?null:  [this.desaturateMatrix] ;

    
  }

  public onMakeBuyRequest=():void=>
  {

    // open the popup 
    // this.activeGameData.BuyBonus.openConfirmation(true);
    //dont open the popup 
    this.activeGameData.BuyBonus.onConfirmBuy();
    
  }



  public setBuyVisible = (bool: boolean): void => {
    if (bool) {
      this.buyButton.alpha = 1;
      this.buyButton.scale.set(1);
      this.cardParent.scale.set(1);
      this.enableBtn(true);
    } else {
      this.buyButton.alpha = 0;
      this.buyButton.scale.set(0);
      this.cardParent.scale.set(this.sideCardScaleX, this.sideCardScaleY);
      this.enableBtn(false);
    }
  };



 
    private moveEndUpdate=():void=>
    {
        this.cardParent.x=0;
        if(this.cardIndex<this.totalCards-2)
        {
          this.setVisibleAfterAnimation(true);
        }
        else
        {
          this.setVisibleAfterAnimation(false);
        }
 
        
        // this.updatePrice(this.serverValue);
        if(this.cardIndex==0 && this.totalCards>1)
        {
          this.activeGameData.BuyBonus.onMoveComplete();
        }
       
        
    }
  public updatePrice = (serVerValue: number): void => {
    // this.serverValue=serVerValue;
    let client = convertCreditsFromServerToClient(serVerValue).toFixed(2);
    let decimals = client.substring(client.length - 2, client.length);
    let wholeNumber = client.substring(0, client.length - 2);
    this.text_prizeWholeNumber.text = wholeNumber;
    this.text_prizeDecimal.text = decimals;

    this.priceContainer.x =
      this.text_prizeWholeNumber.width - this.priceContainer.width / 2;
    if (this.priceContainer.width > this.cardSize[0]) {
      // this.priceContainer.width=  this.cardSize[0];
    }
    this.priceContainer.x =
      this.text_prizeWholeNumber.width - this.priceContainer.width / 2;
  };

  private onHover = (): void => {
    // do something
    this.buyButton.scale.set(1.12);
  };

  private onOut = (): void => {
    // do something
    this.buyButton.scale.set(1.0);
  };

  public setPosition(posX: number, posY: number) {
    this.parent.position.set(posX, posY);
  }
//--
  public setPortraitMode=(bool:boolean):void=>
  {   
    let scale=1
    if(bool)
    {
      scale=1;
    }
    this.parent.scale.set(scale);
    this.isPortrait=bool;

  }
  public setVisibleAfterAnimation=(bool:boolean):void=>
  {
      this.cardParent.alpha=bool?1:0;
      this.setBuyClickable(bool);
   
  }

  private isEnoughBalToBuy=():boolean=>
  {
  
    //--do the check and fisable the buy btn
    let betSelected=this.activeGameData.betSelected.value;
    let playerBalance=this.activeGameData.betResponse.playerBalance.creditsBalance.amount;
    // console.log(betSelected,playerBalance)
    // ;
    let bonusBuyPrice=betSelected*this.activeGameData.loginResponse.gameSettings.buyBonusFactor;

    if(bonusBuyPrice<=playerBalance)
    {
      return true
    }
    else
    {
      return false
    }
   
  }

  private grayOutCheck=(bool:boolean):void=>
  {
    if(this.isEnoughBalToBuy())
    {
      // console.log('player can buy , enough balance ')
      this.enableBtn(bool);
    }
    else
    {
      // console.log('player cant buy , balance insuffisent')
      this.enableBtn(false);
    }
  }
  public setBuyClickable=(bool:boolean):void=>
  { 
    if(this.cardParent.alpha>0)
    {

     this.grayOutCheck(bool);

      
    }
    else
    {
      this.enableBtn(false);
    }
   
  }
  private setOffset=():void=>
  {
    if(this.isPortrait)
    {
      this.offsetMove=this.offSetValuePortrait;
    }
    else
    {
      this.offsetMove=this.offSetValuelandscape;
    }
  }
  public moveLeft=():void=>
  { 
    this.setOffset();
    this.setBuyClickable(false);
    this.tweenMoveLeft.stop();
    this.tweenMoveRight.stop();
    this.cardParent.x=0;
    this.tweenMoveLeft.reset();



    if(this.cardIndex==(this.totalCards-1))
    {
        this.tweenMoveLeft
        .from({ alpha: 0  })
        .to({ alpha: 0});
    }
    else if(this.cardIndex==0)
    {
        this.tweenMoveLeft
        .from({ alpha: 1, x: 0,scale:{x:1,y:1} })
        .to({ alpha:0 , x:- this.offsetMove });
    }
    else if(this.cardIndex==(this.totalCards-2))
    {
        this.tweenMoveLeft
        .from({ alpha: 0, x: 0,scale:{x:1,y:1} })
        .to({ alpha:1 , x:- this.offsetMove});
    }
    else
    {
        this.tweenMoveLeft
        .from({ alpha: 1, x: 0})
        .to({ alpha: 1, x: - this.offsetMove});
    }

    this.tweenMoveLeft.start();
  }

  public moveRight=():void=>
  {
    this.setOffset();
    this.setBuyClickable(false);
    this.tweenMoveLeft.stop();
    this.tweenMoveRight.stop();
    this.cardParent.x=0;
    this.tweenMoveLeft.reset();

    if(this.cardIndex==(this.totalCards-2))
    {
        this.tweenMoveRight
        .from({ alpha: 0  })
        .to({ alpha: 0});
    }
    else if(this.cardIndex==this.totalCards-3)
    {
        this.tweenMoveRight
        .from({ alpha: 1, x: 0,scale:{x:1,y:1} })
        .to({ alpha:0 , x: this.offsetMove });
    }
    else if(this.cardIndex==(this.totalCards-1))
    {
        this.tweenMoveRight
        .from({ alpha: 0, x: 0,scale:{x:1,y:1} })
        .to({ alpha:1 , x: this.offsetMove});
    }
    else
    {
        this.tweenMoveRight
        .from({ alpha: 1, x: 0})
        .to({ alpha: 1, x:  this.offsetMove});
    }

    this.tweenMoveRight.start();
  }

  public disableBuyBtn=():void=>
  {
    this.buyButton.filters=   [this.desaturateMatrix] 
  }
  public setNewTextureCard=(cardnameWithExtension:string):void=>
  {
    this.promotionPicture.texture= PIXI.Texture.fromFrame(cardnameWithExtension);
  }
}
